import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { TermDto, CreateTermRequestDto } from '@/types/dtos/events/term.dto.ts';
import { GET_TERMS_QUERY_KEY } from '../../queries/events/use-get-terms.ts';

export const useCreateTermMutation = (options?: { onSuccess?: (data: TermDto) => void }) => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ eventId, data }: { eventId: string; data: CreateTermRequestDto }) => {
      const token = await getToken();
      return createTerm({ eventId, data, token: token ?? '' });
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [GET_TERMS_QUERY_KEY, variables.eventId],
      });
      options?.onSuccess?.(data);
    },
  });
};

const createTerm = async ({
  eventId,
  data,
  token,
}: {
  eventId: string;
  data: CreateTermRequestDto;
  token: string;
}): Promise<TermDto> => {
  const url = `${import.meta.env.VITE_API_URL}/events/${eventId}/terms`;
  return sendJSONRequest({
    url,
    method: METHOD.POST,
    body: data,
    token,
  });
};
